import { FacilityType } from "./types";

export const PRIMARY_FACILITIES: FacilityType[] = [
  "bag",
  "cabin",
  "baggage",
  "baggage_paid",
  "meal",
];

export const EXTRA_FACILITIES: FacilityType[] = [
  "entertainment",
  "wifi",
  "power",
  "aircraft",
  "seatLayout",
  "seatPitch",
];
